const GuideNames = {
  BULK_USER_UPLOAD_GUIDE: "bulkUserUploadGuide"
} as const;

export default GuideNames;
